import React from 'react';

export type UndoSnackbarProps = {
  open: boolean;
  message: React.ReactNode;
  onUndo: () => void;
  onDismiss: () => void;
  width?: number;
  bottom?: number;
};

const UndoSnackbar: React.FC<UndoSnackbarProps> = ({ open, message, onUndo, onDismiss, width = 450, bottom = 24 }) => {
  if (!open) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        left: '50%',
        bottom,
        transform: 'translateX(-50%)',
        zIndex: 11000,
        width,
        height: 46,
        opacity: 1,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: 13,
          paddingRight: 10,
          paddingBottom: 13,
          paddingLeft: 10,
          boxSizing: 'border-box',
          width: '100%',
          height: '100%',
          borderRadius: 8,
          background: '#F1F7FF',
          color: '#2F58F2',
          boxShadow: '0 12px 40px rgba(17, 24, 39, 0.18)',
        }}
      >
        <div style={{ fontSize: '0.95rem', fontWeight: 600, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {message}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '14px', flex: '0 0 auto' }}>
          <button
            type="button"
            onClick={onUndo}
            style={{
              border: 'none',
              background: 'transparent',
              padding: 0,
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              fontSize: '0.95rem',
              fontWeight: 700,
              color: '#2F58F2',
            }}
            title="Undo"
          >
            <img src="/images/undo.svg" alt="Undo" style={{ width: 18, height: 18, display: 'block' }} />
            <span>Undo</span>
          </button>

          <button
            type="button"
            aria-label="Dismiss"
            title="Close"
            onClick={onDismiss}
            style={{
              border: 'none',
              background: 'transparent',
              padding: 0,
              cursor: 'pointer',
              fontSize: '1.2rem',
              lineHeight: 1,
              color: '#2F58F2',
              opacity: 0.9,
            }}
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
};

export default UndoSnackbar;
